module.exports = __webpack_public_path__ + "img/biaoq.f789b2de.png";